import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../hooks";
import { useState } from "react";
import { BasicSelector } from "../ui";
import { setLang } from "../../store/langSlice";
import axios from "axios";
import { MdLanguage, MdLockOutline, MdLogout, MdPersonOutline } from "react-icons/md";

const normalizeLanguageCode = (value) => String(value || "").trim().toLowerCase();

const getLanguageLabel = (language) => {
  const code = normalizeLanguageCode(language?.langCode || language?.value || language?.code || language);
  const rawName = String(language?.langName || language?.name || "").trim();
  if (code === "ar") return "عربي";
  if (code === "en") return "English";
  if (rawName && rawName.toLowerCase() !== "language") return rawName;
  return code || rawName;
};

const UserBar = ({ tenantUsername, tenantImage, tenant }) => {
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getUser } = useUser();
  const _token = localStorage.getItem("token");

  const langSelected = useSelector((state) => state.lang);
  const user = useSelector((state) => state.auth).user;
  const currentCompany = useSelector((state) => state.currentCompany);
  const currentBranch = useSelector((state) => state.currentBranch);
  const currentLangValue = String(langSelected?.value || i18n.language || "ar")
    .toLowerCase()
    .startsWith("ar")
    ? "ar"
    : "en";
  const listLangHandler =
    tenant?.languages?.map((language) => ({
      label: getLanguageLabel(language),
      value: normalizeLanguageCode(language?.langCode || language?.value || language?.code),
    })).filter((language) => language.value) || [];

  const logoutHandler = () => {
    navigate(`/${tenantUsername}/logout`);
  };

  const onSelectedUserList = (item) => {
    switch (item.value) {
      case "MyAccount":
        navigate(`/${tenantUsername}/settings`, { state: { tab: "profile" } });
        break;
      case "ChangePassword":
        navigate(`/${tenantUsername}/settings`, { state: { tab: "password" } });
        break;
      case "Logout":
        logoutHandler();
        break;
      default:
        break;
    }
  };

  const [openListUser, setOpenListUser] = useState(false);
  const userList = [
    { label: "حسابي", value: "MyAccount", icon: <MdPersonOutline size={16} /> },
    { label: "تغيير كلمة المرور", value: "ChangePassword", icon: <MdLockOutline size={16} /> },
    { label: "تسجيل الخروج", value: "Logout", icon: <MdLogout size={16} /> },
  ];
  const saveCentralSelection = async (selectedCompanyId, selectedBranchId, selectedLang) => {
    if (!user?.tenant_id) return;
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      await axios.put(
        `${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,
        {
          tenantId: user.tenant_id,
          scope: "header-selection",
          data: {
            selectedCompanyId,
            selectedBranchId,
            selectedLang,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: () => true,
        }
      );
    } catch (error) {}
  };
  const onSelectedLangHandler = (lang) => {
    const normalizedLang = String(lang?.value || "").toLowerCase().startsWith("ar") ? "ar" : "en";
    try {
      localStorage.setItem("preferredLang", normalizedLang);
      localStorage.setItem("appLang", normalizedLang);
      localStorage.setItem("i18nextLng", normalizedLang);
    } catch {}
    const dir = normalizedLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = normalizedLang;
    document.documentElement.dir = dir;
    document.body.dir = dir;
    document.body.classList.remove("rtl", "ltr");
    document.body.classList.add(dir);
    i18n.changeLanguage(normalizedLang);
    dispatch(setLang({ label: lang.label, value: normalizedLang }));
    saveCentralSelection(
      currentCompany?.value || user?.company_id,
      currentBranch?.value || user?.branch_id,
      normalizedLang
    );
  };
  const toggleLangHandler = () => {
    const nextLangValue = currentLangValue === "ar" ? "en" : "ar";
    const nextLang = listLangHandler.find((lang) => lang.value === nextLangValue) || {
      label: nextLangValue === "ar" ? "عربي" : "English",
      value: nextLangValue,
    };
    onSelectedLangHandler(nextLang);
  };

     return (
        <div className="flex text-white flex-wrap items-center justify-between gap-2 text-xs md:justify-end md:me-[-21px] w-full px-2">
        <BasicSelector
          border={false}
          listItem={userList}
          label={getUser?.name}
          defaultValue={getUser?.name}
          openList={openListUser}
          setOpenList={setOpenListUser}
          withChangeLabel={false}
          onSelected={onSelectedUserList}
        >
          {tenantImage ?
          <img
          className="w-5 me-3 h-5"
          src={tenantImage}
          alt="User Avatar"
          />
          :
          <img
          className="w-5 me-1 h-5 "
          src="/icons/avatar-3637425_640.png"
          alt="User Avatar"
          />
        }
        </BasicSelector>
  
        <img
          className="w-4 hover:w-[18.5px]  cursor-pointer transition-[0.7s]"
          src="/icons/notification.png"
          alt="Notifications"
        />
  
        <Link
          className="px-1"
          target="_blank"
          to={`https://support.absat-erp.com/${tenantUsername}/token/${_token}`}
        >
          <img className="w-5 hover:w-[21.5px] transition-[0.7s]" src="/icons/(4).png" alt="Help" />
        </Link>
  
        {/* رابط الإعدادات */}
        {/* <Link className="px-1" to={`:tenant/settings`}>
          <img className="w-5 hover:w-[21.5px] transition-[0.7s]" src="/icons/settings.png" alt="Settings" />
        </Link> */}
  
        <button
          type="button"
          onClick={toggleLangHandler}
          className="cursor-pointer text-xs flex items-center justify-center whitespace-nowrap transition-all hover:text-indigo-200 px-2 me-2"
          aria-label="Toggle language"
          title={currentLangValue === "ar" ? "English" : "عربي"}
        >
          <span className="inline-flex h-6 w-6 items-center justify-center text-[18px] leading-none">
            <MdLanguage size={19} />
          </span>
        </button>
      </div>
    )
};

export default UserBar;
